/* @flow weak */
import React from 'react';
import Textarea from 'components/Textarea.jsx';
import KeyConstants from 'constants/KeyConstants';

import './styles/ActivityNotesFieldColumn.scss';

export default class ActivityNotesFieldColumn extends React.Component {
  static propTypes = {
    onClick: React.PropTypes.func,
    onInputSave: React.PropTypes.func,
    onChange: React.PropTypes.func,
    initialValue: React.PropTypes.string,
    editMode: React.PropTypes.bool,
  };

  static defaultProps = {
    onClick: () => {},
    onInputBlur: () => {},
    onChange: () => {},
    initialValue: '',
    editMode: false,
  };

  state = {
    hover: false,
  };

  handleKeyPress = (event) => {
    if (event.keyCode === KeyConstants.ENTER) {
      this.props.onInputSave(event.currentTarget.value);
      this.setState({ hover: false });
    }
  }

  handleMouseOver = () => {
    this.setState({ hover: true });
  }

  handleMouseOut = () => {
    this.setState({ hover: false });
  }

  onChange = (event) => {
    this.props.onChange(event.currentTarget.value);
  }

  onBlur = (event) => {
    this.props.onInputSave(event.currentTarget.value);
  }

  render() {
    return (
      <div
        className="ActivityNotesFieldColumn"
        onClick={this.props.onClick}
        onMouseEnter={this.handleMouseOver}
        onMouseLeave={this.handleMouseOut}>
        <Textarea
          autogrow
          rows={1}
          className="ActivityNotesFieldColumn-input"
          placeholder="Add a note"
          value={this.props.initialValue}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onKeyDown={this.handleKeyPress}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/ActivityNotesFieldColumn.jsx